import axios from '../../axios';

const path = 'treatment';
const service = {
  createTreatment(data) {
    return axios({ method: 'post', url: `${path}/store`, data });
  },

  createTreatments(data) {
    return axios({ method: 'post', url: `${path}/store/bulk`, data: { treatmentData: data } });
  },

  fetchTreatments(params) {
    return axios({ method: 'get', url: `${path}/index`, params });
  },

  fetchTreatmentUOM() {
    return axios({ method: 'get', url: `${path}/uom` });
  },

  fetchTreatmentTypes() {
    return axios({ method: 'get', url: `${path}/types` });
  },

  deleteTreatments(ids) {
    return axios({ method: 'delete', url: `${path}/destroy_bulk`, data: { ids } });
  }
};

export default service;
